
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface AIServiceParams {
  feature: string;
  data?: any;
  query?: string;
  industry?: string;
  userId?: string;
  interactionType?: string;
}

export const useOpenAIService = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState<string>('');

  const callAIService = async (params: AIServiceParams) => {
    setIsLoading(true);
    setResponse('');

    try {
      console.log('Calling AI service with params:', params);

      const { data, error } = await supabase.functions.invoke('openai-service', {
        body: params,
      });

      console.log('AI service response:', { data, error });

      if (error) {
        console.error('Supabase function error:', error);
        throw new Error(`Function error: ${error.message}`);
      }

      if (!data) {
        console.error('No data received from AI service');
        throw new Error('No data received from AI service');
      }

      if (!data.success) {
        console.error('AI service returned failure:', data);
        throw new Error(data.error || 'AI service returned failure');
      }

      if (!data.response) {
        console.error('No response content in data:', data);
        throw new Error('No response content received');
      }

      console.log('Successfully received AI response');
      setResponse(data.response);
      return data.response;
    } catch (error) {
      console.error('AI Service Error:', error);
      const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
      toast.error(`AI Service failed: ${errorMessage}`);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    callAIService,
    isLoading,
    response,
    setResponse
  };
};
